// Return a one-time translation from the textbox origin to the source ink box.
export function isolatedGlyphTranslation(object, box) {
  if (!box || Array.from(String(object.text).trim()).length !== 1) return null;
  const context = object.getMeasuringContext();
  context.save();
  context.font = object._getFontDeclaration(object.getCompleteStyleDeclaration(0, 0));
  context.textBaseline = 'alphabetic';
  context.textAlign = 'left';
  const metrics = context.measureText(object.text);
  context.restore();
  const {actualBoundingBoxLeft: left, actualBoundingBoxRight: right,
    actualBoundingBoxAscent: ascent, actualBoundingBoxDescent: descent} = metrics;
  if (![left, right, ascent, descent, box.width, box.height].every(Number.isFinite)) return null;
  const baseline = object.getHeightOfLine(0) / object.lineHeight * (1 - object._fontSizeFraction);
  const inkX = object._getLineLeftOffset(0) + (right - left) / 2;
  const inkY = baseline + (descent - ascent) / 2;
  const dx = (box.width / 2 - inkX) * (object.scaleX || 1);
  const dy = (box.height / 2 - inkY) * (object.scaleY || 1);
  const angle = object.angle * Math.PI / 180;
  return {x: dx * Math.cos(angle) - dy * Math.sin(angle),
    y: dx * Math.sin(angle) + dy * Math.cos(angle)};
}
